"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_1 = require("@bimser/common");
const components_1 = require("@bimser/components");
const BCListEditor_1 = require("@bimser/components/dist/BCListEditor");
const BCPropertyInspector_1 = require("@bimser/components/dist/BCPropertyInspector");
const core_1 = require("@bimser/core");
const add_1 = tslib_1.__importDefault(require("@bimser/icons/16/add"));
const variable_1 = tslib_1.__importDefault(require("@bimser/icons/16/variable"));
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const localizedFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/localizedFormat"));
const Plugins = tslib_1.__importStar(require("../../plugins"));
dayjs_1.default.extend(localizedFormat_1.default);
class PrimitiveArrayEditor extends BCListEditor_1.StatefulListEditor {
    constructor(props) {
        var _a, _b;
        super(props);
        this.parameterTypes = [
            {
                key: 'String',
                text: components_1.findMessage.get('100204'),
                value: 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */
            },
            {
                key: 'Integer',
                text: components_1.findMessage.get('100205'),
                value: 3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */
            },
            {
                key: 'Float',
                text: components_1.findMessage.get('100206'),
                value: 4 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Float */
            },
            {
                key: 'Boolean',
                text: components_1.findMessage.get('100209'),
                value: 2 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Boolean */
            },
            {
                key: 'Date',
                text: components_1.findMessage.get('100207'),
                value: 6 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTime */
            },
            {
                key: 'Time',
                text: components_1.findMessage.get('100514'),
                value: 8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */
            }
        ];
        this.onClickRibbonItem = this.onClickRibbonItem.bind(this);
        this.setCurrentDataType = this.setCurrentDataType.bind(this);
        const subType = ((_a = this.props
            .itemExternalProps) === null || _a === void 0 ? void 0 : _a.getSubType)
            ? (_b = this.props.itemExternalProps) === null || _b === void 0 ? void 0 : _b.getSubType()
            : 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */;
        this.state = Object.assign(Object.assign({}, this.state), { items: this.props.startupData.map((i, index) => ({
                id: index.toString(),
                externalData: { value: i, key: index.toString() }
            })), leftRibbonItems: this.getRibbonItems(subType), showLoading: false, currentDataType: subType });
    }
    setCurrentDataType(externalData) {
        if (this.state.currentDataType != externalData.value &&
            this.state.items.length > 0 &&
            !(this.isNumber(this.state.currentDataType) && this.isNumber(externalData.value))) {
            common_1.MessageBox.confirm({
                buttons: common_1.MessageBoxButtons.YesNo,
                content: components_1.findMessage.get('102415')
            }).then(result => {
                if (result.button.id === common_1.MessageBoxButton.Yes) {
                    if (this.props.onChangeSubType) {
                        this.props.onChangeSubType(externalData.value);
                    }
                    this.setState({
                        items: [
                            {
                                id: '0',
                                externalData: {
                                    key: '0',
                                    value: this.getDefaultValue(externalData.value)
                                }
                            }
                        ],
                        currentDataType: externalData.value,
                        selectedIndex: 0
                    });
                }
            });
        }
        else {
            this.setState({
                items: [
                    ...this.state.items.map(i => {
                        i.selected = false;
                        return i;
                    }),
                    {
                        id: this.state.items.length.toString(),
                        externalData: {
                            key: this.state.items.length.toString(),
                            value: this.getDefaultValue(externalData.value)
                        }
                    }
                ],
                currentDataType: externalData.value,
                selectedIndex: this.state.items.length
            });
        }
    }
    getRibbonItems(initialDataType) {
        const ribbonItems = [];
        if (this.props.disableTypeSelector) {
            ribbonItems.push({
                key: 'new',
                buttonProps: {
                    title: components_1.findMessage.get('100016'),
                    children: components_1.findMessage.get('100016'),
                    icon: (0, jsx_runtime_1.jsx)(add_1.default, {}),
                    onClick: () => this.onClickRibbonItem(),
                    type: 'text'
                }
            });
        }
        if (!this.props.disableTypeSelector) {
            ribbonItems.push({
                key: 'valueType',
                buttonProps: {
                    title: components_1.findMessage.get('100210'),
                    children: components_1.findMessage.get('100210'),
                    icon: (0, jsx_runtime_1.jsx)(add_1.default, {}),
                    onClick: () => this.onClickRibbonItem(),
                    type: 'text'
                },
                items: this.parameterTypes.map(i => {
                    return {
                        key: i.key,
                        buttonProps: {
                            title: i.text,
                            children: i.text,
                            type: 'text',
                            onClick: () => this.setCurrentDataType(i)
                        }
                    };
                })
            });
        }
        return ribbonItems;
    }
    showDeleteConfirm() {
        return new Promise((resolve, reject) => {
            common_1.MessageBox.confirm({
                buttons: common_1.MessageBoxButtons.YesNo,
                content: components_1.findMessage.get('100653'),
                props: {
                    zIndex: 1100
                }
            }).then(result => {
                resolve(result.button.id === common_1.MessageBoxButton.Yes);
            });
        });
    }
    onOkClick() {
        this.validation().then(message => {
            if (!message && this.props.onSucces) {
                this.props.onSucces({
                    newData: this.state.items.map(i => i.externalData),
                    subType: this.state.currentDataType
                });
                this.onCancelClick();
            }
            else {
                components_1.BCNotification.warning({
                    description: message,
                    message: components_1.findMessage.get('100652') + ' !'
                });
            }
        });
    }
    validation() {
        return new Promise((resolve, reject) => {
            let message = '';
            for (let i = 0; i < this.state.items.length; i++) {
                const item = this.state.items[i].externalData;
                if ((0, core_1.isNullOrUndefined)(item.value)) {
                    message = components_1.findMessage.get('101345');
                }
            }
            resolve(message);
        });
    }
    onClickRibbonItem() {
        this.setState({
            items: [
                ...this.state.items.map(i => {
                    i.selected = false;
                    return i;
                }),
                {
                    id: this.state.items.length.toString(),
                    externalData: {
                        key: this.state.items.length.toString(),
                        value: this.getDefaultValue()
                    }
                }
            ],
            selectedIndex: this.state.items.length
        });
    }
    getDefaultValue(currentData) {
        switch (currentData !== null && currentData !== void 0 ? currentData : this.state.currentDataType) {
            case 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */:
                return '';
            case 4 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Float */:
            case 3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */:
                return null;
            case 2 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Boolean */:
                return false;
            case 8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */:
                return new Date().toISOString();
            case 6 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTime */:
                return new Date().toISOString();
        }
    }
    generateItems() {
        return this.state.items.map((i, index) => {
            const text = this.getText(i.externalData.value);
            return Object.assign(Object.assign({}, i), { icon: variable_1.default.info, showDelete: true, text: text, selected: index === this.state.selectedIndex, externalData: Object.assign(Object.assign({}, i.externalData), { value: text }) });
        });
    }
    getText(value) {
        let text = (0, core_1.isNullOrUndefined)(value) ? '' : value.toString();
        const date = (0, dayjs_1.default)(value);
        if (this.state.currentDataType === 8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */) {
            text = date.isValid() ? date.format('HH:mm:ss') : value;
        }
        else if (this.state.currentDataType === 6 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTime */) {
            text = date.format('L');
        }
        return text;
    }
    isNumber(dataType) {
        return (dataType === 3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */ ||
            dataType === 4 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Float */);
    }
    getCompareValueType() {
        switch (this.state.currentDataType) {
            case 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */:
                return BCPropertyInspector_1.IPropertyTypes.Input;
            case 2 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Boolean */:
                return BCPropertyInspector_1.IPropertyTypes.Switch;
            case 3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */:
            case 4 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Float */:
                return BCPropertyInspector_1.IPropertyTypes.InputNumber;
            case 6 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTime */:
                return BCPropertyInspector_1.IPropertyTypes.DatePicker;
            case 8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */:
                return BCPropertyInspector_1.IPropertyTypes.TimePicker;
            default:
                return BCPropertyInspector_1.IPropertyTypes.Input;
        }
    }
    generateStructure() {
        return this.state.selectedIndex >= 0
            ? [
                {
                    label: components_1.findMessage.get('100061'),
                    key: 'general',
                    properties: [
                        {
                            key: 'value',
                            label: components_1.findMessage.get('100168'),
                            type: this.getCompareValueType(),
                            externalData: {
                                isInteger: this.state.currentDataType ===
                                    3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */
                            },
                            options: {
                                type: this.state.currentDataType ===
                                    8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */
                                    ? 'time'
                                    : 'date'
                            }
                        }
                    ]
                }
            ]
            : [];
    }
}
exports.default = PrimitiveArrayEditor;
//# sourceMappingURL=PrimitiveArrayEditor.js.map